import { inject, Service } from '@angular/core';
import { ServicesService } from '../services';

@Service()
export class UserUnifiedEndpointService {
  readonly #service = inject(ServicesService);

  fetchUserData() {
    return this.#service.userService('me');
  }
}
